import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useLoader } from '../../../../../__legacy__/helpers/useLoader';
import { IRenameAttachmentBl } from '../../RenameAttachment.bl';
import { IRenameAttachmentStore } from '../../RenameAttachment.store';
import { RenameAttachmentModal } from './RenameAttachmentModal';

export const RenameAttachmentModalContainer = observer((): ReactElement => {
  const bl = useInjection(IRenameAttachmentBl.$);
  const store = useInjection(IRenameAttachmentStore.$);

  const { withLoaderAsync } = useLoader();

  const handleSubmit = async (): Promise<void> => {
    await withLoaderAsync(async () => bl.renameAttachmentAsync(), 'rename-attachment-key');
  };

  const handleHide = (): void => {
    bl.hideModal();
  };

  const handleNameChange = (name: string): void => {
    bl.changeName(name);
  };

  return (
    <RenameAttachmentModal
      show={store.showModal}
      onSubmit={handleSubmit}
      onHide={handleHide}
      nameStatus={store.nameStatus}
      name={store.name}
      onNameChange={handleNameChange}
    />
  );
});
